import { arrayDiff } from "utils/array_difference"
import SlimSelect from 'slim-select'

class SortBySelectWidget {
  constructor(widgetParams={}) {
    this.dropdown = null
    this.selectType = widgetParams.selectType
    this.buildWidget(widgetParams)
  }

  buildWidget(widgetParams) {
    const customRenderFn = (renderParams, isFirstRendering) => {
      const container = document.getElementById(renderParams.widgetParams.container)
      const title = renderParams.widgetParams.title || "Filter by"
      const attribute = renderParams.widgetParams.attribute

      if (isFirstRendering) {
        const select = document.createElement('select')

        container.appendChild(select)
        this.dropdown = this.buildSelect(container, renderParams)

        const data = this.loadDataValues(renderParams)

        this.selectedValue = data.filter((el) => { return el.selected || el.options }).map((el) => {
          if (el.options) {
            return el.options.filter((el) => { return el.selected }).map((el) => { return el.value })
          } else {
            return el.value
          }
        }).flat()

        this.dropdown.setData(data)
      }
    }

    this.mainWidget = (widgetParams.connector || instantsearch.connectors.connectSortBy)(customRenderFn)
  }

  get widget(){
    return this.mainWidget
  }

  set widget(widget) {
    this.mainWidget = widget
  }

  sortItems(renderParams, data, selectedValue) {
    const newItems = data.value && data.value !== this.placeholderText ? [data.value] : []

    const itemsToRefine = arrayDiff(this.selectedValue, newItems)
    this.selectedValue = [data.value]
    itemsToRefine.forEach((item) => { renderParams.refine(item) })
  }

  buildSelect(container, renderParams) {
    return new SlimSelect({
      select: container.querySelector("select"),
      settings: {
        placeholderText: this.placeholderText,
        showSearch: false
      },
      events: {
        afterChange: (data) => {
          this.sortItems(renderParams, data[0], this.selectedValue)
        }
      }
    })
  }

  loadDataValues(renderParams) {
    const data = renderParams.widgetParams.items.map((staticItem) => {
      return {
        value: staticItem.value,
        text: staticItem.label,
        selected: (staticItem.value.toString() === renderParams.currentRefinement)
      }
    })

    return data.flat()
  }
}

export default SortBySelectWidget
